import { render, staticRenderFns } from "./Itemcodescan.vue?vue&type=template&id=66b3c532"
import script from "./Itemcodescan.vue?vue&type=script&lang=js"
export * from "./Itemcodescan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports